import React from 'react';

import { StyleSheet } from 'react-native';

import Dialog from 'components/dialog';
import { Box, BoxProps, withTypography } from 'components/ui';
import { spacing } from 'styles/constants';

export const DialogContainer = Dialog.withConfig({
  background: 'blackOpacity.80',
});

export const ContentContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { style: [styles.contentContainer, style], ...props });

export const ModalHeading = withTypography({
  variant: 'headerOne',
  style: {
    marginTop: spacing.$2,
  },
});

export const ModalBody = withTypography({
  fontSize: 'sm',
  style: {
    marginVertical: spacing.$2,
  },
});

const styles = StyleSheet.create({
  contentContainer: {
    marginBottom: spacing.$6,
    paddingVertical: 0,
  },
});
